import { AppBar, Box, Toolbar } from '@mui/material';

import LanguagePickerButton from 'components/@common/LanguagePickerButton';
import HideOnScroll from 'components/@navigation/HideOnScroll';

const AccountNavigation = () => {
  return (
    <Box sx={{ display: { xs: 'block', md: 'none' } }}>
      <HideOnScroll>
        <AppBar color="default">
          <Toolbar sx={{ justifyContent: 'flex-end', p: 2, gap: 1 }}>
            <LanguagePickerButton />
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar sx={{ minHeight: 72 }} />
    </Box>
  );
};

export default AccountNavigation;
